import { MediaContent } from "trunx"

import { CALL_PAGE } from "../../common/constants"

import styles from "./style.module.scss"

import { ImgAvatar } from "components"
import { formatTitlesShort, getFaceUrl } from "utils/helpers/psychologistUtil"
import { Media, Text } from "@components-branded/index"

interface Props {
    displayName?: string
    faceUrl?: string
    titles?: string[]
    companionLocation?: CALL_PAGE
}

export function UserInfo({ titles, displayName, faceUrl, companionLocation }: Props) {
    return (
        <Media>
            <div className="image media-left">
                {faceUrl !== undefined ? (
                    <ImgAvatar
                        src={getFaceUrl(faceUrl)}
                        size="S"
                        fallback={() => (
                            <div className="user-info__photo-placeholder">
                                {displayName?.slice(0, 1)}
                            </div>
                        )}
                    />
                ) : (
                    <div className={styles.placeholder}>{displayName?.slice(0, 1)}</div>
                )}
            </div>
            <MediaContent>
                <div>
                    <Text>{displayName}</Text>
                    {companionLocation === CALL_PAGE.ROOM && (
                        <>
                            <span className={styles.bullet}>•</span>
                            <Text>уже на звонке</Text>
                        </>
                    )}
                </div>
                <Text className={styles.title}>{formatTitlesShort(titles)}</Text>
            </MediaContent>
        </Media>
    )
}
